import { Injectable, inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import {
    type CurrentIdentity,
    CurrentIdentityService,
} from "@firm360/libs/domain/core";
import _isEqual from "lodash-es/isEqual";
import { type Observable, distinctUntilChanged, filter, map } from "rxjs";

import type { PendoProfile } from "../../pendo-profile.model";
import type { PendoProfileSource } from "../pendo-profile-source";

/** The ids and the person on the current identity, once the server provides them. */
@Injectable()
export class IdentityProfileSource implements PendoProfileSource {
    private readonly _identity$ = toObservable(
        inject(CurrentIdentityService).currentIdentity,
    );

    contribute$(token: string): Observable<PendoProfile> {
        return this._identity$.pipe(
            filter((identity) => identity?.token === token),
            filter(hasIds),
            map((identity) => ({
                visitor: {
                    id: identity.pendo.visitorId,
                    email: identity.email,
                    firstName: identity.firstName,
                    lastName: identity.lastName,
                },
                account: { id: identity.pendo.accountId },
            })),
            distinctUntilChanged(_isEqual),
        );
    }
}

type IdentityWithIds = CurrentIdentity &
    Required<Pick<CurrentIdentity, "pendo">>;

function hasIds(identity: CurrentIdentity | null): identity is IdentityWithIds {
    return !!identity?.pendo;
}
